/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

/**
 * POST /balance body
 */
export interface BalanceUpdate {
  /**
   * account id of the balance to modify
   */
  accountId: string;
  /**
   * The amount to modify the balance by (positive or negative)
   */
  amountDiff: string;
}
